/**
 * Created by Ivan on 10.08.2026
 */

const StickersCollection2 = function (options) {
    cleverapps.EventEmitter.call(this);

    this.isPrizeCollected = options.isPrizeCollected;
    this.isCompleted = false;

    this.index = options.index;
    this.season = options.season;

    this.createStickers(options);

    const [year, seasonIndex] = this.season.split("_");
    this.title = `Collection.${year}.season${seasonIndex}.collection${this.index}.Title`;
};

StickersCollection2.prototype = Object.create(cleverapps.EventEmitter.prototype);
StickersCollection2.prototype.constructor = StickersCollection2;

StickersCollection2.prototype.createStickers = function (options) {
    this.stickers = [];

    options.stickers.forEach((state, i) => {
        const [year, seasonIndex] = this.season.split("_");
        const title = `Sticker2.${year}.season${seasonIndex}.collection${this.index}.sticker${i}.Title`;

        const sticker = new Sticker2({
            collection: this,
            state,
            image: bundles[SeasonCollectionsHelper2.getCollectionBundleName(this.index, this.season)].frames[`sticker_${i}_png`],
            rarity: this.calculateRarity(i),
            title,
            attention: i < options.attention.length ? options.attention[i] : false
        });
        sticker.on("update", this.onStickerUpdate.bind(this));
        this.stickers.push(sticker);
    });

    this.onStickerUpdate();
};

StickersCollection2.prototype.getInfo = function () {
    return {
        isPrizeCollected: this.isPrizeCollected,
        stickers: this.stickers.map((sticker) => sticker.getState())
    };
};

StickersCollection2.prototype.onPrizeCollect = function () {
    this.isPrizeCollected = true;
    cleverapps.stickersBook2.save();
    this.trigger("update");
};

StickersCollection2.prototype.onStickerUpdate = function () {
    let isCompleted = true;

    for (let i = 0; i < this.stickers.length; i++) {
        if (StickersBook2.isPuzzle() && this.stickers[i].hasAttention()) {
            isCompleted = false;
        }

        if (this.stickers[i].getState() === Sticker2.STATE_CLOSED) {
            isCompleted = false;
        }
    }

    if (isCompleted) {
        this.setCompleted();
    }

    this.trigger("update");
};

StickersCollection2.prototype.setCompleted = function () {
    this.isCompleted = true;
    this.trigger("complete");
};

StickersCollection2.prototype.getOpenedStickersAmount = function (withoutAttention) {
    return this.stickers.filter((sticker) => {
        if (StickersBook2.isPuzzle() && !withoutAttention) {
            return sticker.getState() === Sticker2.STATE_OPENED && !sticker.hasAttention();
        } 
        return sticker.getState() === Sticker2.STATE_OPENED;
    }).length;
};

StickersCollection2.prototype.isAvailable = function () {
    return true;
};

StickersCollection2.prototype.isCollected = function () {
    return this.getOpenedStickersAmount(true) === StickersCollection2.STICKERS_IN_COLLECTION;
};

StickersCollection2.prototype.hasAttention = function () {
    return this.stickers.filter((sticker) => sticker.hasAttention()).length;
};

StickersCollection2.prototype.getAttentionInfo = function () {
    return this.stickers.map((sticker) => sticker.hasAttention());
};

StickersCollection2.prototype.updateAttention = function (data) {
    this.stickers.forEach((sticker, index) => {
        sticker.setAttention(data[index]);
    });
};

StickersCollection2.prototype.resetAttention = function () {
    this.stickers.forEach((sticker) => {
        sticker.setAttention(false);
    });
    this.trigger("hideAttention");
};

StickersCollection2.prototype.calculateRarity = function (stickerIndex) {
    let cumulativeRarity = 0;
    let result = 0;
    for (let i = 0; i < StickersCollection2.COLLECTION_CONFIG[this.index].length; i++) {
        cumulativeRarity += StickersCollection2.COLLECTION_CONFIG[this.index][i];
        if (stickerIndex < cumulativeRarity) {
            result = i;
            break;
        }
    }
    return result;
};

StickersCollection2.getCollectionBundle = function (index, season) {
    return SeasonCollectionsHelper2.getCollectionBundleName(index, season);
};

StickersCollection2.STICKERS_IN_COLLECTION = 9;

StickersCollection2.REGULAR_POINTS = 5;
StickersCollection2.RARE_POINTS = 25;
StickersCollection2.GOAL_POINTS = 200;

StickersCollection2.RARITIES = [0, 1, 2, 3, 4, 5];
StickersCollection2.DROP_PROBABILITIES = [0.3435, 0.2623, 0.1756, 0.1062, 0.0625, 0.05];

StickersCollection2.COLLECTION_CONFIG = [
    [8, 1, 0, 0, 0, 0],
    [7, 2, 0, 0, 0, 0],
    [7, 1, 1, 0, 0, 0],
    [5, 3, 1, 0, 0, 0],
    [3, 4, 1, 1, 0, 0],
    [2, 4, 1, 1, 1, 0],
    [1, 3, 2, 1, 1, 1],
    [0, 4, 2, 1, 1, 1],
    [0, 3, 2, 1, 2, 1],
    [0, 2, 2, 2, 1, 2],
    [0, 1, 3, 1, 2, 2],
    [0, 0, 3, 2, 2, 2],
    [0, 0, 3, 2, 1, 3],
    [0, 0, 2, 2, 2, 3],
    [0, 0, 0, 4, 2, 3]
];